module.exports = __webpack_public_path__ + "cancellara-dist/img/static-content-homepage.8422e7ec.jpg";